/**
 * Academic year helpers (Sep start, Aug end — matches server OrgStatModel).
 */

export function getDefaultAcademicYear() {
    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    const day = now.getDate();

    // ken: the cut off date is June 24
    const afterCutOff = month >= 6 && day >= 24;
    
    return afterCutOff ? year : year - 1;
}

export function getRecentAcademicYears(count = 3) {
    const base = getDefaultAcademicYear();
    return Array.from({ length: count }, (_, i) => base - i);
}

export function getAcademicYearDateRange(year, startMonth = 9) {
    const y = parseInt(year, 10);
    if (startMonth === 1) {
        return [`${y}-01-01`, `${y}-12-31`];
    }
    const startMonthStr = String(startMonth).padStart(2, "0");
    const startDate = `${y}-${startMonthStr}-01`;
    const nextYearStart = `${y + 1}-${startMonthStr}-01`;
    const endDate = new Date(nextYearStart);
    endDate.setDate(endDate.getDate() - 1);
    const end = endDate.toISOString().slice(0, 10);
    return [startDate, end];
}

/** year=0 means all academic years */
export const ALL_ACADEMIC_YEARS = 0;

export function formatAcademicYearLabel(year) {
    const y = parseInt(year, 10);
    if (y === ALL_ACADEMIC_YEARS) return "全部";
    return `${y}學年`;
}

/** e.g. 2026 → "2026-2027"; 0 → "全部" */
export function formatAcademicYearRangeLabel(year) {
    const y = parseInt(year, 10);
    if (y === ALL_ACADEMIC_YEARS) return "全部";
    return `${y}-${y + 1}`;
}
